import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {LoaderState} from './loader.enum';
import {CommonModule} from '@angular/common';

@Component({
    selector: 'app-loading-indicator',
    templateUrl: './loading-indicator.component.html',
    styleUrls: ['./loading-indicator.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule]
})
export class LoadingIndicatorComponent implements OnInit {
  @Input() state: LoaderState;
  @Output() update = new EventEmitter();
  public loaderState =  LoaderState;

  constructor() {
  }

  ngOnInit() {
    return;
  }

}
